import { useEffect, useRef, useState } from "react";
import { Button, Input, Space, Table, Tooltip , notification , Row , Col} from "antd";
import { cloneDeep,get ,map } from "lodash";

import Icon from "@assets/icon_config";
import "./table.scss";
import { FilterConfirmProps } from "antd/lib/table/interface";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import ModalCustom from "@components/modal-custom";
import UserManagementService from "../../../../../services/user-managament.service"
import { CanEdit } from '@components/accessLevel'
import { useConfigStore } from "@stores/useConfigStore";
import { TableLocale } from "@components/noDataFound";
const TableComponent = ({usersData, columnData , setisEditUserModalOpen ,editUserFields ,  setEditUserFields , setEditRowData , dropdownData}: any) => {
  // const [searchText, setSearchText] = useState('');
  // const [searchedColumn, setSearchedColumn] = useState('');
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [tableData, setTableData] = useState<Array<any>>([]);
  const rowactiveStatus = useRef<any>({});
  const [columnSearchInfo, setColumnSearchInfo] = useState({});
  useEffect(() => {
    console.log("userManagmentTable.useEffect")
    setTableData(usersData);
  }, [usersData])
  
  const handleOk = () => {
    console.log("userManagmentTable.handleOk")
    setIsModalVisible(false);
    UserManagementService.changeUserStatus(rowactiveStatus.current).subscribe({
      next: (res : any) => {
        const copyTableData = cloneDeep(tableData);
        const index = copyTableData.findIndex((data : any) => data.user_email === rowactiveStatus.current.user_email);
        copyTableData[index].is_active = copyTableData[index].is_active === "Y" ? "N" : "Y";
        setTableData(copyTableData);
        notification.success({
          message: "Success",
          description: `User is ${rowactiveStatus.current.operation === 'ACTIVATE' ? 'Activated' : 'Deleted'} Successfully`,
        });
      },
      error: () => {},
    })
  }

  const rowSelection = {
    hideSelectAll: true,
    renderCell: (checked: any, record: any, index: any, originNode: any) => (
      <CanEdit hide={false}>
      <div
        onClick={(e) => {
          e.stopPropagation();
          if(record.is_active === 'Y') {
            rowactiveStatus.current = {id : record.user_id , user_first_name : record.user_first_name , user_last_name : record.user_last_name ,user_email : record.user_email ,  operation : "DELETE"};
          } else {
            rowactiveStatus.current = {id : record.user_id , user_first_name : record.user_first_name , user_last_name : record.user_last_name ,user_email : record.user_email , operation : "ACTIVATE"};
          }
          setIsModalVisible(true);
        }}
      >
        <span className={`tableComponent__row-selection}`}><Icon name={record.is_active === "Y" ? "eye-non-restricted" : "eye-restricted"}/></span>
      </div>
      </CanEdit>
    ),
    onselect: (record: any, selected: any, selectedRows: any, nativeEvent: any) => console.log(record, selected, selectedRows, nativeEvent),
  };

  const highlighterDiv = (text: any, record: any , dataIndex : string) => {
    if(text?.includes('$|')) {
      text = text?.split("$|")?.join(" , ")
    }
    return (
      <span className={`${record.is_active === "Y" ? "nonDeletedRow" : "deletedRow"} table-content-style`}>
      <Tooltip placement="topLeft" title={text ? text.toString() : ""}>
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0}}
          className={`${record.is_active === "Y" ? "nonDeletedRow" : "deletedRow"} table-content-style`}
          searchWords={[get(columnSearchInfo, dataIndex, "")]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      </Tooltip>
      </span>
    );
  };

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: any,
  ) => {
    confirm();
    // setSearchText(selectedKeys[0]);
    // setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void, confirm: (param?: FilterConfirmProps) => void,) => {
    clearFilters();
    // setSearchText('');
    confirm();
  };

  const inputref = useRef<any>(null);
  const getColumnSearchProps = (dataIndex: any, label: string): any => ({   
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }:any) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={inputref}
          placeholder={`Search ${label}`}
          value={selectedKeys[0]}
          onChange={e => {setColumnSearchInfo({
            ...columnSearchInfo,
            [dataIndex]: e.target.value,
          });setSelectedKeys(e.target.value ? [e.target.value] : [])}}
          onPressEnter={(e) => {handleSearch(selectedKeys as string[], confirm, dataIndex); e.stopPropagation()}}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={(e) => {setColumnSearchInfo({ ...columnSearchInfo,
              [dataIndex]: get(columnSearchInfo, dataIndex, ""),});
              ;handleSearch(selectedKeys as string[], confirm, dataIndex)}}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {setColumnSearchInfo({ ...columnSearchInfo,
              [dataIndex]: "" });clearFilters && handleReset(clearFilters, confirm)}}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? '#EF6D2A' : undefined }} />
    ),
    onFilterDropdownOpenChange: (visible:any) => {
      if (visible) {
        setTimeout(() => inputref.current?.select(), 100);
      }
    },
    onFilter: (value : any, record : any) =>
    record[dataIndex] ? 
      record[dataIndex]?.toString()?.toLowerCase()?.includes((value as string)?.toLowerCase()) : "",
    render: (text: any, record: any) =>
        highlighterDiv( text, record , dataIndex)
  });

  const column: any = [
    ...columnData
      ?.filter((col: any) => col?.isDisplay  === "Y")
      ?.map((colConfig: any) => {
        return {
          title: colConfig?.tableHeaderName,
          dataIndex: colConfig?.dataIndex,
          key: colConfig?.dataIndex,
          width : 150,
          ellipsis: true,
          className: `small-column`,
          sorter: (a: any, b: any) => {
            a[colConfig?.dataIndex] = a[colConfig?.dataIndex] ? a[colConfig?.dataIndex] : "";
            b[colConfig?.dataIndex] = b[colConfig?.dataIndex] ? b[colConfig?.dataIndex] : "";
            return a[colConfig?.dataIndex]?.localeCompare(b[colConfig?.dataIndex]);
          },
          ...getColumnSearchProps(colConfig?.dataIndex, colConfig?.displayName),
        };
      }),
  ];

  const getEditUser = (record : any, editUserFields : any) => {
    console.log("userManagmentTable.getEditUser")
    setisEditUserModalOpen(true);
    const data = cloneDeep(editUserFields);
    data.forEach((col : any) => {
      if(col.dataIndex === 'user_role'){
        col.value = dropdownData[dropdownData.findIndex((d : any) => d.dropdownName === 'user_role')]?.data?.find((da : any) => da?.title === record[col.dataIndex])?.value || record[col.dataIndex];
      } else {
        col.value = record[col.dataIndex];
      }
      if(col.dataIndex === 'office_name'){
        const secondaryOfficeIndex = data.findIndex((col: any) => col.dataIndex === 'secondary_office_name');
        if(col.value === 'ALL'){
          data[secondaryOfficeIndex].value = '';
          data[secondaryOfficeIndex].className = 'dnone';
          data[secondaryOfficeIndex].errorMessage = '';
        } else {
          data[secondaryOfficeIndex].className = '';
        }
      }
    });
    setEditRowData(record);
    setEditUserFields(data);
  }

  const canEdit = useConfigStore(store => store.canEdit)

  return (
    <div>
    <div className={`user__management--table tableEditMode ${!(usersData?.length > 0 && columnData?.length > 0 ) ? "dnone" : ""} `}>
      <Table
        columns={column}
        dataSource={tableData}
        rowSelection={ rowSelection }
        // tableLayout="fixed"
        onRow={(record, rowIndex) => {
          return {
            onClick: canEdit() ? (event) => {
              event.stopPropagation();
              getEditUser(record , editUserFields)
            } : undefined,
          };
        }}
        bordered={true}
        pagination={{
          defaultPageSize: 5,
          showSizeChanger: true,
          pageSizeOptions: ["5", "10", "15", "20", "25", "30"],
          showTotal : ((total, range) => {
            return <span className="paginationData">{`${range[0]} to ${range[1]} of ${total}`}</span>
           })
        }}
        scroll={{ x: true}}
        locale={TableLocale}
      />
      </div>
      <Row className={`tableWrapper ${(usersData?.length > 0 && columnData?.length > 0 ) ? "dnone" : ""}`}>
            <Col span={24}>
              <TablePreloader />
              <div className="pagination">
                <div className="rowperpage_preloader shimmerBG"></div>
                <div className="pagination_text_preloader shimmerBG"></div>
              </div>
            </Col>
          </Row>
      <ModalCustom title={"Alert"} visible={isModalVisible} width={500}  onOk={handleOk} setVisible ={setIsModalVisible} cancelText={"Cancel"} zIndex={2}  text={`You are trying to ${rowactiveStatus?.current?.operation} the User. Do you want to continue ?`}/>
    </div>
  );
};

export default TableComponent;

const TablePreloader = () => {
  return (
    <div className="table-preloader">
      {map(Array.from(Array(6).keys()), (item : any) => {
        return (
          <div className="table-preloader__row" key={"row_" + item}>
            {map(Array.from(Array(8).keys()), (item : any) => {
              return (
                <div key={"col_" + item} className="table-preloader__row__column">
                  <div className="table-preloader__row__column__title shimmerBG"></div>
                  <div className="table-preloader__row__column__sub-title shimmerBG"></div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};
